import React, { FunctionComponent } from 'react';
import { pathOr } from 'ramda';

import { useMerchantAudiences } from 'helpers/useMerchantAudiences';

import FormSelectList from 'components/FormComponents/FormSelect';

import { defaultPriorityByAudienceExternalID } from 'scenes/Home/scenes/MerchantStatusDetails/scenes/sections/MerchantOffers/MerchantOffer.helpers';

export interface AttachedAudiences {
  [key: string]: string[][];
}

type Props = {
  currentAudienceUuid?: string | null;
  attachedAudiences?: AttachedAudiences;
  onSelectChange: Function;
  disabled?: boolean;
  merchantId: string;
  filterAttachedAudiences?: boolean;
};

export type AudienceSelectEvent = {
  audienceId: string;
  defaultPriority: number;
  audienceDates: string[][];
};

const SelectAudience: FunctionComponent<Props> = ({
  currentAudienceUuid,
  attachedAudiences = {},
  disabled = false,
  merchantId,
  onSelectChange,
  filterAttachedAudiences = false,
}) => {
  const {
    audienceDropdown,
    audienceById,
    filteredAudienceDropdown,
  } = useMerchantAudiences(merchantId);
  const options = filterAttachedAudiences
    ? filteredAudienceDropdown(Object.keys(attachedAudiences))
    : audienceDropdown;

  const handleAudienceChange = (audienceId: string) => {
    const externalId = pathOr('', [audienceId, 'externalId'], audienceById);
    const defaultPriority = defaultPriorityByAudienceExternalID(externalId);
    const audienceDates = attachedAudiences[audienceId];
    onSelectChange({
      audienceId,
      defaultPriority,
      audienceDates,
    } as AudienceSelectEvent);
  };

  return (
    <FormSelectList
      label="Audience"
      name="audience"
      disabled={disabled}
      dropDownOptions={options}
      onSelectChange={handleAudienceChange}
      defaultValue={currentAudienceUuid}
    />
  );
};

export default SelectAudience;
